const normalizeModelForAria = (model) => {
  if (!model) return model
  if (model === 'repurchase' || model === 'recovery' || model === 'activation') {
    return model
  }
  let normalized = model.replace(/^category_/, '')
  if (normalized === 'rescue') {
    normalized = 'recovery'
  }
  if (normalized === 'repurchase' || normalized === 'activation') {
    return normalized
  }
  return normalized
}

export function processTemplate(template, data, options = {}) {
  const v = data || {}
  const { includeModel = false, defaultModel = null } = options

  let ariaOfferValue
  if (includeModel) {
    const model = v.model || defaultModel || 'category_activation'
    const normalizedModel = normalizeModelForAria(model)
    ariaOfferValue = 'best-offer-' + normalizedModel + '-' + (v.bestOffer || '1')
  } else {
    ariaOfferValue = 'best-offer-' + (v.bestOffer || '1')
  }

  return template
    .replace(/\{\{mecanica\s+oferta\}\}/g, v['mecanica oferta'] || '')
    .replace(/\{\{nome\s+da\s+oferta\}\}/g, v['nome da oferta'] || '')
    .replace(/\{\{unidade\}\}/g, v.unidade || '')
    .replace(/\{\{fim\s+da\s+validade\}\}/g, v['fim da validade'] || '')
    .replace(/\{\{desconto\s+da\s+oferta\}\}/g, v['desconto da oferta'] || '')
    .replace(/\{\{imagem\s+da\s+oferta\}\}/g, v['imagem da oferta'] || '')
    .replace(/\{\{regra\s+min\s+max\}\}/g, v['regra min max'] || '')
    .replace(/\{\{bestOffer\}\}/g, ariaOfferValue)
}

export function getProcessTemplateCode(options = {}) {
  const { includeModel = false, defaultModelValue = 'category_activation' } = options

  const normalizeModelCode = `function normalizeModelForAria(model) {
    if (!model) return model;
    if (model === 'repurchase' || model === 'recovery' || model === 'activation') {
      return model;
    }
    let normalized = model.replace(/^category_/, '');
    if (normalized === 'rescue') {
      normalized = 'recovery';
    }
    if (normalized === 'repurchase' || normalized === 'activation') {
      return normalized;
    }
    return normalized;
  }`

  const ariaOfferValueCode = includeModel
    ? `${normalizeModelCode}
    const model = v.model || (typeof defaultModel !== 'undefined' ? defaultModel : '${defaultModelValue}');
    const normalizedModel = normalizeModelForAria(model);
    const ariaOfferValue = 'best-offer-' + normalizedModel + '-' + (v.bestOffer || '1');`
    : `const ariaOfferValue = 'best-offer-' + (v.bestOffer || '1');`

  return `function (template, data) {
    const v = data || {};
    ${ariaOfferValueCode}
    
    const nomeDaOfertaValue = v['nome da oferta'] || '';
    const result = template
      .replace(/\\{\\{mecanica\\s+oferta\\}\\}/g, v['mecanica oferta'] || '')
      .replace(/\\{\\{nome\\s+da\\s+oferta\\}\\}/g, nomeDaOfertaValue)
      .replace(/\\{\\{unidade\\}\\}/g, v.unidade || '')
      .replace(/\\{\\{fim\\s+da\\s+validade\\}\\}/g, v['fim da validade'] || '')
      .replace(/\\{\\{desconto\\s+da\\s+oferta\\}\\}/g, v['desconto da oferta'] || '')
      .replace(/\\{\\{imagem\\s+da\\s+oferta\\}\\}/g, v['imagem da oferta'] || '')
      .replace(/\\{\\{regra\\s+min\\s+max\\}\\}/g, v['regra min max'] || '')
      .replace(/\\{\\{bestOffer\\}\\}/g, ariaOfferValue);
    return result;
  }`
}

export function isLargeComponent(values, isMounted, detectedSize) {
  if (values && values.templateSize && values.templateSize !== 'auto') {
    return values.templateSize === 'large'
  }

  if (isMounted && detectedSize !== null) {
    return detectedSize
  }
  return false
}

export function detectComponentSize(element) {
  const parentColumn = element.closest('.u_column, .u-column')
  if (parentColumn) {
    const parentRow = parentColumn.closest('.u_row, .u-row')
    if (parentRow) {
      const columnsInRow = parentRow.querySelectorAll('.u_column, .u-column')
      const columnCount = columnsInRow.length

      if (columnCount === 1) {
        return true
      } else if (columnCount === 2) {
        const currentColumn = parentColumn
        const columnClasses = currentColumn.className

        if (columnClasses.includes('u-col-50') || columnClasses.includes('u-col-33.33')) {
          return false
        } else if (columnClasses.includes('u-col-66.67')) {
          return true
        } else {
          return true
        }
      } else {
        return false
      }
    }
  }
  return false
}

export function notifySizeChange(onSizeChange, newSize) {
  if (onSizeChange && typeof onSizeChange === 'function') {
    onSizeChange(newSize)
  }
}
